import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider, useTheme } from "./context/ThemeContext";
import "react-tooltip/dist/react-tooltip.css";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Customers from "./pages/Customers";
import Categories from "./pages/Categories";
import Products from "./pages/Products";
import ProductForm from "./pages/ProductForm";
import ProductBulkUpload from "./pages/ProductBulkUpload";
import TaxClasses from "./pages/TaxClasses";
import Orders from "./pages/Orders";
import Invoices from "./pages/Invoices";
import Ledger from "./pages/Ledger";
import Forms from "./pages/Forms";
import FormBuilder from "./pages/FormBuilder";
import Disputes from "./pages/Disputes";
import Notifications from "./pages/Notifications";
import NotificationControl from "./pages/NotificationControl";
import Settings from "./pages/Settings";
import Maintenance from "./pages/Maintenance";
import LoginSecurity from "./pages/LoginSecurity";
import AdminAccount from "./pages/AdminAccount";
import Promotions from "./pages/Promotions";
import Newsletters from "./pages/Newsletters";
import Collections from "./pages/Collections";
import OptionTemplates from "./pages/OptionTemplates";
import RolesPermissions from "./pages/RolesPermissions";
import ProductionManagement from "./pages/ProductionManagement";
import Questionnaires from "./pages/Questionnaires";
import Vendors from "./pages/Vendors";

import AccessDeniedDialog from "./components/AccessDeniedDialog";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import ProfileDash from "./pages/ProfileDash";

import "./assets/styles/admin.css";
import "./assets/styles/responsive.css";
import "./assets/styles/admin-polish.css";

const ThemedToastContainer = () => {
  const { theme } = useTheme();

  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme={theme.mode}
      transition={Slide}
    />
  );
};

function App() {
  const protectedPage = (Component) => (
    <ProtectedRoute>
      <Component />
    </ProtectedRoute>
  );

  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>

          <Routes>
            <Route
              path="/"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />

            <Route path="/dashboard" element={protectedPage(Dashboard)} />
            <Route path="/users" element={protectedPage(Users)} />
            <Route path="/customers" element={protectedPage(Customers)} />
            <Route path="/categories" element={protectedPage(Categories)} />
            <Route path="/products" element={protectedPage(Products)} />
            <Route path="/products/add" element={protectedPage(ProductForm)} />
            <Route path="/products/edit/:product_id" element={protectedPage(ProductForm)} />
            <Route path="/products/bulk-upload" element={protectedPage(ProductBulkUpload)} />
            <Route path="/tax-classes" element={protectedPage(TaxClasses)} />
            <Route path="/orders" element={protectedPage(Orders)} />
            <Route path="/production" element={protectedPage(ProductionManagement)} />
            <Route path="/vendors" element={protectedPage(Vendors)} />
            <Route path="/questionnaires" element={protectedPage(Questionnaires)} />
            <Route path="/invoices" element={protectedPage(Invoices)} />
            <Route path="/ledger" element={protectedPage(Ledger)} />
            <Route path="/forms" element={protectedPage(Forms)} />
            <Route path="/forms/add" element={protectedPage(FormBuilder)} />
            <Route path="/forms/edit/:form_id" element={protectedPage(FormBuilder)} />
            <Route path="/disputes" element={protectedPage(Disputes)} />
            <Route path="/notifications" element={protectedPage(Notifications)} />
            <Route path="/notification-control" element={protectedPage(NotificationControl)} />
            <Route path="/settings" element={protectedPage(Settings)} />
            <Route path="/maintenance" element={protectedPage(Maintenance)} />
            <Route path="/login-security" element={protectedPage(LoginSecurity)} />
            <Route path="/account" element={protectedPage(AdminAccount)} />
            <Route path="/promotions" element={protectedPage(Promotions)} />
            <Route path="/newsletters" element={protectedPage(Newsletters)} />
            <Route path="/collections" element={protectedPage(Collections)} />
            <Route path="/option-templates" element={protectedPage(OptionTemplates)} />
            <Route path="/roles-permissions" element={protectedPage(RolesPermissions)} />
            {/* <Route path="*" element={<Navigate to="/dashboard" replace />} /> */}
            <Route path="/ProfileDash" element={protectedPage(ProfileDash)} />
          </Routes>
          <ThemedToastContainer />
          <AccessDeniedDialog />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
